import { isObject } from 'es-toolkit/compat';
import { isString } from 'es-toolkit/compat';
import { getKeyJson, updateKeyJson, getsubKey, removeKeys } from '../localStorage';

import { useUserStore } from '../../store/modules/user';

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export function joinTimestamp<T extends boolean>(join: boolean, restful: T): T extends true ? string : object;

export function joinTimestamp(join: boolean, restful = false): string | object {
  if (!join) {
    return restful ? '' : {};
  }
  const now = new Date().getTime();
  if (restful) {
    return `?_t=${now}`;
  }
  return { _t: now };
}

// 格式化提交参数时间
export function formatRequestDate(params: Recordable) {
  if (Object.prototype.toString.call(params) !== '[object Object]') {
    return;
  }

  for (const key in params) {
    // eslint-disable-next-line no-underscore-dangle
    if (params[key] && params[key]._isAMomentObject) {
      params[key] = params[key].format(DATE_TIME_FORMAT);
    }
    if (isString(key)) {
      const value = params[key];
      if (value) {
        try {
          params[key] = isString(value) ? value.trim() : value;
        } catch (error: any) {
          throw new Error(error);
        }
      }
    }
    if (isObject(params[key])) {
      formatRequestDate(params[key]);
    }
  }
}

// 将对象转为Url参数
export function setObjToUrlParams(baseUrl: string, obj: object): string {
  let parameters = '';
  for (const key in obj) {
    parameters += `${key}=${encodeURIComponent(obj[key])}&`;
  }
  parameters = parameters.replace(/&$/, '');
  return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters;
}

// 在提交前增加auth及sid等（对于图片来说，如果没有sid，是找不到图片的）
export function fmtHeadersAuthSid(headers: any) {
  const userStore = useUserStore();
  const auth: any = getKeyJson('auth');
  const { sid } = userStore;
  if (auth) {
    // jwt token --自动判断是租户token还是租户的客户token
    if(auth['tu']){
      headers['token'] =auth['token'];
      headers['salt'] = auth['salt'];
      headers['tu'] = auth['tu'];
    }else{
      headers['Authorization'] = auth['token'];
      headers['rft'] = auth['refresh'];
      headers['salt'] = auth['salt'];
    }
  }
  if (sid) {
    headers.sid = sid;
  }else{
    headers.sid = 10000000;    
  }

  //跨域处理，不能仅放在axios那里，因为比如getPdf等也要调用此处
  //if(`${headers['url']}`.includes('localhost')){     
  //  headers['Access-Control-Allow-Origin'] = 'https://www.d3inf.com'; 
  //  headers['Access-Control-Allow-Methods'] = 'POST, GET, OPTIONS'; 
  //  headers['Access-Control-Allow-Headers'] = 'X-Requested-With'; 
  //  headers['Access-Control-Allow-Headers'] = 'Content-Type'; 
  //} 
}
